import * as React from "react"
import { Flex } from "@chakra-ui/react"
import { HeartIcon } from "./heart-icon"
import { DesktopMainScreenButtonsProps } from "./buttons-main-screen.interface"
import { HandIcon } from "./hand-icon"
import { ShareIcon } from "./share-icon"
import { useRecoilValue } from "recoil"
import { LeaveMeetingButton } from "../leave-overlay"
import { brandingSelector } from "../../../recoil/atoms/room"

export const DesktopMainScreenButtons: React.FC<DesktopMainScreenButtonsProps> = ({
  isHandIcon,
  localUserProperties,
  isHeartIcon,
  showLeaveButton = false,
  showHandButton = true,
  showHeartButton = true,
  showShareButton = true  
}) => {
  const roomStyles = useRecoilValue(brandingSelector)

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center">
      {showShareButton && <ShareIcon isMobile={false} />}
      {showHandButton && (
        <HandIcon
          showIcon={isHandIcon}
          isMobile={false}
          localUserProperties={localUserProperties}
          isHeartIcon={isHeartIcon}
        />
      )}
      {showHeartButton && (
        <HeartIcon
          showIcon={isHeartIcon}
          isMobile={false}
          localUserProperties={localUserProperties}
        />
      )}
      {showLeaveButton && (
        <LeaveMeetingButton
          color={roomStyles?.overlayEmojiStrokeColor ?? "white"}
          backgroundColor={"rgba(0, 0, 0, 0.2)"}
        />
      )}
    </Flex>
  )
}
